import React from 'react';
import { createPortal } from 'react-dom';
import '../styles/menu-drawer.css';

/**
 * MenuDrawer - App-level navigation menu (left hamburger)
 * Follows mobile UX patterns: Sessions, Documents, Settings, Help, About
 * Separate from session-specific actions (right three dots)
 */
const MenuDrawer = ({ 
  isOpen, 
  onClose, 
  onOpenSessions,
  onOpenDocuments,
  onOpenSettings,
  onOpenHelp,
  onOpenAbout,
  vertical = 'business'
}) => {
  if (!isOpen) return null;

  const isOpsIQ = vertical === 'opsiq' || vertical === 'business';

  const content = (
    <>
      <div className="ov-menu-overlay" onClick={onClose} />
      <div className="ov-menu-drawer">
        <div className="ov-menu-header">
          <h2>Menu</h2>
          <button
            className="ov-menu-close"
            onClick={onClose}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>

        <div className="ov-menu-items">
          <button
            className="ov-menu-item"
            onClick={() => {
              onOpenSessions();
              onClose();
            }}
            aria-label="View conversation history"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
            Sessions
          </button>

          {isOpsIQ && onOpenDocuments && (
            <button 
              className="ov-menu-item"
              onClick={() => {
                onOpenDocuments();
                onClose();
              }}
              aria-label="View documents"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
              </svg>
              Documents
            </button>
          )}

          <div style={{ height: '1px', background: '#E5E7EB', margin: '0.75rem 0' }}/>

          {onOpenSettings && (
            <button 
              className="ov-menu-item"
              onClick={() => {
                onOpenSettings();
                onClose();
              }}
              aria-label="Settings"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="3"/>
                <path d="M12 1v6m0 6v6M5.64 5.64l4.24 4.24m4.24 4.24l4.24 4.24M1 12h6m6 0h6M5.64 18.36l4.24-4.24m4.24-4.24l4.24-4.24"/>
              </svg>
              Settings
            </button>
          )}

          {onOpenHelp && (
            <button 
              className="ov-menu-item"
              onClick={() => {
                onOpenHelp();
                onClose();
              }}
              aria-label="Help & Support"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
              Help & Support
            </button>
          )}

          {onOpenAbout && (
            <button 
              className="ov-menu-item"
              onClick={() => {
                onOpenAbout();
                onClose();
              }}
              aria-label="About"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                <path d="M12 8v4"/><path d="M12 16h.01"/>
              </svg>
              About
            </button>
          )}
        </div>
      </div>
    </>
  );

  // Portal to <body> so it's not affected by widget stacking contexts/transforms.
  if (typeof document !== 'undefined' && document.body) {
    return createPortal(content, document.body);
  }
  return content;
};

export default MenuDrawer;
